import { createdATFilter } from 'modules/common/constants';

export const conciliationAdjustmentCausesFilters = [createdATFilter];
